import { render, staticRenderFns } from "./ProduceList.vue?vue&type=template&id=2b591a0c&scoped=true&"
import script from "./ProduceList.vue?vue&type=script&lang=js&"
export * from "./ProduceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b591a0c",
  null
  
)

export default component.exports